import { FormField, TextInput } from 'grommet';

export const ApplicationUrl = (): JSX.Element => {
  return (
    <FormField
      name="application"
      htmlFor="application-url"
      label="Application URL"
      required
    >
      <TextInput
        id="application-url"
        name="application"
        placeholder="Application URL (Ex : https://support.hpe.com/)"
      />
    </FormField>
  );
};
